import React from 'react';
import * as Styled from './style';
import ChatbotDemoForm from '../forms/ChatbotDemoForm';

export default function DemoFormSection() {
  return (

    <Styled.Section id="demo-form">
      <Styled.Container>
        <Styled.Left>
          <Styled.Heading>
            Book a demo now to see our chatbot in action
          </Styled.Heading>
          <Styled.Description>
            Our AI-powered chatbot is completely free. Fill out this form to
            schedule a demo and preview what you’ll get by adding the power of
            AI to your business.
          </Styled.Description>
        </Styled.Left>

        <Styled.Right>
          <ChatbotDemoForm />
        </Styled.Right>
      </Styled.Container>
    </Styled.Section>
  );
}
